import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDialog } from '../../../core/actions';
import ModalDialog from '../../../core/components/Modal';
import { checkErrors } from '../../../core/formValidation';
import * as actions from '../actions';
import InventoryEditForm from '../components/InventoryEditForm';
import { InventoryType } from '../models';
import { selectInventoryInEdit } from '../reducer';

const initialFormValues = {
  number: null,
  name: null,
  description: null,
  installedAt: null,
  stockLevel: null,
  vendorUrl: null,
  unitOfMeasure: 'Number',
  priority: false,
};

class UpsertInventoryDialog extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
    initialInventory: PropTypes.shape({}).isRequired,
    onSubmit: PropTypes.func.isRequired,
    isNew: PropTypes.bool,
    title: PropTypes.string.isRequired,
    intl: PropTypes.shape({}),
    isEssentialPart: PropTypes.bool,
  };

  formRef = React.createRef();

  onReady = () => {
    if (this.formRef && this.formRef.current && this.formRef.current.submit) {
      this.formRef.current.submit();
    }
  };

  onSubmit = (item) => {
    const newItem = { ...item };
    // Make sure that the URL is a somewhat working one
    if (item.vendorUrl) {
      const hasHTTP =
        item.vendorUrl.slice(0, 7) === 'http://' || item.vendorUrl.slice(0, 8) === 'https://';
      newItem.vendorUrl = hasHTTP ? item.vendorUrl : `https://${item.vendorUrl}`;
    }
    // Normalize part number field for API compatibility
    if (newItem.partNumber == null && newItem.number != null) {
      newItem.partNumber = newItem.number;
    }
    this.props.onSubmit({ item: newItem });
  };

  render() {
    const { closeDialog, isOpen, initialInventory, isNew, intl, isEssentialPart } = this.props;
    const enableReinitialize = !isNew;
    // RHF form manages validation internally; keep Save enabled here
    const submitDisabled = false;

    if (initialInventory?.employeeId == null) {
      delete initialInventory.employeeId;
    }

    if (isEssentialPart) {
      initialInventory.priority = true;
    }

    return (
      <ModalDialog
        title={this.props.title}
        className="enhanced-dialog"
        onReady={this.onReady}
        isOpen={isOpen}
        close={closeDialog}
        disabled={submitDisabled}
        submitButtonText={intl.formatMessage({ id: 'saveInventory' })}
      >
        <InventoryEditForm
          ref={this.formRef}
          onSubmit={this.onSubmit}
          initialValues={initialInventory}
          inventoryType={initialInventory ? initialInventory.type : InventoryType.Part}
          enableReinitialize={enableReinitialize}
          isEssentialPart={isEssentialPart}
          isNew={isNew}
        />
      </ModalDialog>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const inventoryData = ownProps.isNew ? initialFormValues : selectInventoryInEdit(state);
  const initialInventory = { ...inventoryData };
  return {
    initialInventory,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...actions, closeDialog: hideDialog }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(UpsertInventoryDialog);
